(($) => {
  const $body = $("body");

  const customObj = {
    init: function () {
      if ($body.hasClass("template-collection") || $body.hasClass("template-search")) {
        this.initLoadMore();
      }
    },

    initLoadMore: function () {
      const $paginate = $(".pagination"),
        paginateBtnSelector = ".pagination button.loadMore";
      if (!$paginate.length) return;

      $body.off("click.loadMore", paginateBtnSelector).on("click.loadMore", paginateBtnSelector, function (e) {
        e.preventDefault();
        e.stopPropagation();

        if ($(this).hasClass("disabled") || $(this).parent().hasClass("ajax-loading")) return;

        const url = $(this).data("href");
        customObj.doAjaxLoadMoreGetContent(url);
      });
    },

    doAjaxLoadMoreGetContent: async function (url) {
      let type = "collection-template"; // section type
      let $section = $(`[data-section-type="${type}"]`);
      if($section.length === 0){
        type = "search-template"
        $section = $(`[data-section-type="search-template"]`);
      }

      // Change the type & "search-template" to desired template (for future inclusion)
      // if($section.length === 0){
      //   type = "search-template"
      //   $section = $(`[data-section-type="search-template"]`);
      // }
      
      const $pagination = $section.find(".pagination");
      const $paginationmm = $section.find(".pagi_curr_page_off");
      const $paginatio_bar =  $section.find(".containerBar");
      
      // loading state
      $pagination.addClass("ajax-loading");

      try {
        const response = await fetch(url);
        if (!response.ok) {
          throw new Error("Something went wrong.");
        }

        const text = await response.text();
        const parser = new DOMParser();
        const data = parser.parseFromString(text, "text/html");

        // Map data
        const $data = $(data);
        const $list = $section.find(".product-list");
        const $newSection = $data.find(`[data-section-type="${type}"]`);
        const $newList = $newSection.find(".product-list");
        const $newListItems = $newList.find(".product-block");
        if (!$newListItems.length) return;

        theme.ProductBlockManager.unloadImages($section);

        $list.append($newListItems);

        // init js
        theme.ProductBlockManager.loadImages($section);
        setTimeout(() => {
          $(".product-form:not(.theme-init)", $section).trigger("load-product-form");
        }, 2000);

        // init scroll animations
        theme.initAnimateOnScroll();

        // update button
        $pagination.removeClass("ajax-loading");
        const $newPagination = $newSection.find(".pagination");
        $pagination.html($newPagination.html());

         const $newPaginationnn = $newSection.find(".pagi_curr_page_off");
        $paginationmm.html($newPaginationnn.html());
        
        const $newPagination_bar = $newSection.find(".containerBar");
        $paginatio_bar.html($newPagination_bar.html());
      } catch (error) {
        console.error(error);
        $pagination.removeClass("ajax-loading");
      }
    },
  };

  $(document).ready(() => {
    customObj.init();
  });
})(theme.jQuery);
